import {analyticsLogEvent} from '../api'
import {ProductImpression} from '_types'

const eventName = 'productImpression'

interface Ecommerce {
    currencyCode: string
    dimension25?: string
    impressions: ProductImpression[]
}

interface EventDetails {
    ecommerce: Ecommerce
}

export function analyticsProductImpression({currencyCode, template, impressions}: {currencyCode: string; template?: string; impressions: ProductImpression}) {
    const eventDetails: EventDetails = {
        ecommerce: {
            currencyCode: currencyCode,
            dimension25: template,
            impressions: [impressions],
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
